<template>
  <div>
    <div class="row1">
		<div id="">
			
		</div>
      <div class="dis-flex">
        <el-input
          size="small"
          clearable
          placeholder="搜索广告位名称"
          prefix-icon="el-icon-search"
          v-model="searchVal"
        >
        </el-input>
        <el-button
          @click="onSearch"
          class="row-btn add search"
          type="primary"
          size="small"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="tab-box">
      <el-table
        v-loading="loading"
        element-loading-text="加载中"
        :header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection"> </el-table-column> -->
        <el-table-column label="序号"  align="center">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <el-table-column prop="name" label="客户名称"></el-table-column>
        <el-table-column label="广告位"> 
		  <template slot-scope="scope">
			  <div v-for="(v,k) in scope.row.content.length > 3 ? 3 : scope.row.content.length" :key="k">
				{{scope.row.content[k].name}}
			  </div>
			  <span
			  class="mColor" style="cursor: pointer;"
			  @click="lookAll(scope.row.content)">查看全部</span>
		  </template>
		</el-table-column>
        <el-table-column label="价格"> 
		<template slot-scope="scope">￥{{scope.row.price}}</template>
		</el-table-column>
        <el-table-column label="折扣"> 
			<template slot-scope="scope">{{scope.row.discount}}折</template>
		</el-table-column>
        <el-table-column prop="create_time" label="报价时间"> </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div class="handle-box">
              <span v-if="!scope.row.is_create_order" class="txt-btn txtC" @click="createOrder(scope.row.id)">生成订单</span>
            </div>
			<div class="handle-box">
				<span class="txt-btn txtC" @click="downLoadTab(scope.row.id)">下载报价表</span>
			</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="page-box" v-if="tableData.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20, 30, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
	<!-- 查看更多弹框 -->
	<offer-more :tableData="moreTabData" ref="moreDialog"></offer-more>
  </div>
</template>

<script>
	import offerMore from "../../components/dialog/order/offer.vue";
export default {
	components: {
	  offerMore,
	},
  data() {
    return {
		moreTabData:[],
      tableData: [],
	  pageObj: {
	  	limit: 10,
	  	page: 1,
		filter: {},
		op: {}
	  },
	  total: 0, //总条数
      multipleSelection: [], //勾选的数据
      currentPage: 1, //当前页
      loading: true, //是否显示加载中图标
      searchVal: "", //搜索框值
    };
  },
  created() {
    this.getList();
  },
  methods: {
	  // 获取cookie
	  getCookie(name) {
	   var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	   if (arr = document.cookie.match(reg))
	    return (arr[2]);
	   else
	    return null;
	  },
	  // 下载表格
	  downLoadTab(id){
		// location.href = this.$baseUrl + '/admin/offer/downloadXls?id='+id+'&PHPSESSID='+this.getCookie('PHPSESSID')  
		let url = this.$baseUrl + '/admin/offer/downloadXls?id='+id+'&PHPSESSID='+this.getCookie('PHPSESSID')
		window.open(url)
	  },
	  //查看全部
	  lookAll(item){
		  this.moreTabData = item;
		  this.$refs.moreDialog.dialogVisible = true;
	  },
    //搜索
    onSearch(){
		this.pageObj.page = 1
		// this.pageObj.filter.brand = this.searchVal;
		this.pageObj.filter.name = this.searchVal;
		// this.pageObj.op.brand = '%*%'
		this.pageObj.op.name = '%*%'
		this.getList()
    },
	//生成订单
	createOrder(id){
		this.$confirm('确认生成订单？', '提示').then(() => {
			 this.$api2.createOrder({id:id}).then((res)=>{
			 	if(res.code == 1){
			 		this.$message.success(res.msg)
			 		this.getList()
			 	}else{
			 		this.$message.error(res.msg)
			 	}
			 })
		}).catch(()=>{})
		
	},
    // 获取数据列表
    getList() {
		this.loading = true;
      this.$api2.offerList(this.pageObj).then(res => {
      	this.loading = false;
      	if (res.code == 1) {
      		this.total = res.count;
      		this.tableData = res.data;
      	}
      })
      .catch(err => {
      	this.loading = false;
      });
    },
    // 多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
	  this.pageObj.limit = val;
	  this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
	  this.pageObj.page = val;
	  this.getList();
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/css/public.scss";
.row1 {
  align-items: center;
  justify-content: space-between;
}
.search {
  margin-left: 10px;
  margin-right: 0 !important;
}
.handle-box {
    display: flex;
    justify-content: space-around;
}
</style>